import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IonText } from '@ionic/angular/standalone';
import { Enums } from '@libs/mtjr/shared/generated/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mtjr-order-status-text',
  imports: [IonText, TranslatePipe],
  template: `
    <ion-text [color]="color()" class="text-[16px] capitalize">
      {{ 'ENUMS.OrderStatus.' + status() | translate }}
    </ion-text>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderStatusTextComponent {
  status = input.required<Enums.OrderStatus>();
  color = computed(() => {
    switch (this.status()) {
      case 'pending':
      case 'readyForProcessing':
        return 'primary';
      case 'processing':
      case 'readyForShipping':
        return 'warning';
      case 'shipped':
      case 'delivered':
        return 'success';
      case 'canceled':
        return 'danger';
      default:
        return undefined;
    }
  });
}
